export const mCfg = {
    LOG_SWITCH: true,
}

function phNoFilter(phNo) {
    if (phNo == null || phNo.length < 11) {
        return phNo
    }
    return phNo.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

function icNoFilter(icNo) {
    if (icNo == null || icNo.length < 18) {
        return icNo
    }
    return icNo.replace(/(\d{4})\d{11}(\d{2})([0-9X])/, '$1********$2$3');

}

export default {
    install(vue) {
        console.log("plugins install")

        vue.prototype.NET_ERR_SERVER = "服务器异常,请联系IT运营人员,错误码-"
        vue.prototype.NET_ERR_NETWORK = "网络发生故障，请稍后再试，并请联系网络管理人员"

        vue.mixin({
            methods: {
                showNetErrMsg() {
                    this.$message.error(this.NET_ERR_NETWORK)
                },
                showServerErrMsg(errCode) {
                    this.$message.error(this.NET_ERR_SERVER + errCode)
                },
                httpErrMsg(err) {
                    const data = err && err.response && err.response.data
                    return (data && data.msg) || (err && err.message) || this.NET_ERR_NETWORK
                },
                logD(...data) {
                    if (mCfg.LOG_SWITCH) {
                        console.log(data)
                    }
                },
                logI(...data) {
                    console.info(data)
                },
                logE(...data) {
                    console.error(data)
                },
            }
        })

        vue.filter('phNoFilter', phNoFilter)
        vue.filter('icNoFilter', icNoFilter)


    }//end install
}
